export const LOYALTY_UPGRADE_TO_PRO_BANNER_SHOWN_ON_LISTINGS_AND_EXPIRE_AFTER =
    'LOYALTY_UPGRADE_TO_PRO_BANNER_SHOWN_ON_LISTINGS_AND_EXPIRE_AFTER';
export const THREE_MONTHS_IN_MILLISECONDS = 7776000000;
